const REPOSITION_INTERVAL_MS = 30_000

export const Watermark = {
  _timer: null as ReturnType<typeof setInterval> | null,

  mounted(this: typeof Watermark & { el: HTMLElement }) {
    this._reposition()
    this._timer = setInterval(() => this._reposition(), REPOSITION_INTERVAL_MS)
  },

  destroyed(this: typeof Watermark) {
    if (this._timer !== null) {
      clearInterval(this._timer)
      this._timer = null
    }
  },

  _reposition(this: typeof Watermark & { el: HTMLElement }) {
    // Keep watermark within 10%–80% of each axis so it stays visible
    const top = 10 + Math.floor(Math.random() * 70)
    const left = 10 + Math.floor(Math.random() * 70)
    this.el.style.top = `${top}%`
    this.el.style.left = `${left}%`
  },
}
